import React, { useState } from 'react'
import './styles.scss'
import Button from './../buttons/Button';
import Heading from '../heading/Heading';

const FileList = (props) => {

    let convertFilesize = ( filesize ) => {
        let ext = 'KB';
        let convertToMb = (filesize / 1024).toFixed(2);

        if ( convertToMb >= 1024 ) {
            ext = 'MB';
            convertToMb = (convertToMb / 1024).toFixed(2);
        }
        return convertToMb + ' ' + ext;
    }
    return (
        <>
            <div className="file-list">
                <Heading title="Twoje pliki"   />
                { props.oldFiles?.map( (item, index) => (
                    <div className="file" key={ index }>
                        <div className="name"> { item.name }</div>
                        <div className="size">{ convertFilesize( item.size ) }</div>
                            <div className="delete">
                                { ( index > 0 && props.lastStep )  &&

                                    <Button title="Usuń plik" class="blue reverse" minus={ true } setFunction={ () => props.remove(index) } />
                                }
                            </div>

                        
                    </div>
                ))  }
                { props.files.map( (item, index) => (
                    <div className="file" key={ index }>
                        <div className="name"> { item.name }</div>
                        <div className="size">{ convertFilesize( item.size ) }</div>
                            <div className="delete">
                                <Button title="Usuń plik" class="blue reverse" minus={ true } setFunction={ () => props.remove(index) } />
                            </div>
                    </div>
                ))  }
            </div>
        </>
    )
}

export default FileList;